import React, { useState, useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import './Chats.css'


interface IProps {
  history: any,
  userResponse: string,
  botResponse: {
    purpose: string,
    message: string,
    delay?: number,
    options?: string[],
    sender?: string,
  }
  sendUserResponse: string
  optionClick: (ev: React.MouseEvent<HTMLElement>) => void
}

export interface IMessagesInfo {
  purpose?: string | null
  message?: string
  options?: string[]
  sender?: string
  delay?: number
}



const Chats: React.FC<IProps> = props => {

  const sessionStorageValue = sessionStorage.getItem('chatmessages')
  const myArray = sessionStorageValue ? JSON.parse(sessionStorageValue) : []
  
  const [messages, setMessages] = useState<IMessagesInfo[]>(myArray as IMessagesInfo[])
  const dummyRef = useRef<HTMLDivElement>(null)
  const bodyRef = useRef<HTMLDivElement>(null)
  const bottomRef = useRef<HTMLDivElement>(null)
  const { history } = props


  // stacking up messages
  useEffect(() => {
    if (messages.length === 0) {
      setTimeout(() => setMessages(prev => [...prev, {
        purpose: 'introduction',
        message:
          '¡Hola! 👋 ¡Soy Billybot, su guía para esta cirugía!',
        sender: 'bot',
      }, {
        sender: 'bot',
        message: '<img src="https://uci-images.s3.us-west-1.amazonaws.com/images/chatbot/chatbot-hello.png"/>',
      }]), 1000)
      setTimeout(() => setMessages(prev => [...prev, {
        purpose: 'specify experience',
        message:
          'Aquí hay una lista de artículos con los que puedo ayudar.',
        sender: 'bot',
      }]), 6000)
      setTimeout(() => setMessages(prev => [...prev, {
        purpose: 'specify experience',
        options: [
          'Técnicas de manejo de la ansiedad de los padres',
          'Preguntas frecuentes de los padres',
          'Ideas para distracción',
          'Precauciones de alimentos y bebidas',
          'Proceso de inducción',
          'Consejos en la sala de recuperación',
          'Qué esperar en casa',
          'Identificar el dolor de su hijo en casa',
          'Cambiar/cancelar el día de la cirugía del niño',
          'Comunicarse con el proveedor de atención médica de su hijo',
          'Contactar al equipo L-WebTIPS',
        ],
        sender: 'bot',
      }]), 8000)
    } else {
      const tempArray = [...messages]
      if(props.sendUserResponse !== ''){
        tempArray.push({ message: props.sendUserResponse, sender: 'user' })
        setMessages(tempArray)
      }

      setTimeout(() => {
        if(props.botResponse.message !== ''){
          const temp2 = [...tempArray]
          temp2.push(props.botResponse)
          setMessages(temp2)
        }
        
      }, 500)
    }
  }, [props.sendUserResponse, props.botResponse])

  // enable autoscroll after each message
  useEffect(() => {
    window.sessionStorage.setItem('chatmessages', JSON.stringify(messages))
    if (bottomRef && bottomRef.current && dummyRef && dummyRef.current && bodyRef && bodyRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [messages, myArray])

  function CustomParagraph({message}:{message: string}) {
    // const history = useHistory();
  
    function handleMouseDown(event: any) {
      const link = (event.target as Element).closest('a')
      if (link && link.hasAttribute('data-href')) {
        event.preventDefault()
        const realhref = link.getAttribute('data-href')
        history.push(realhref)
      }
    }
  
    return (
      <p onMouseDown={handleMouseDown} dangerouslySetInnerHTML={{ __html: message }} />
    )
  }

  return (
    <div className="message-container" ref={bodyRef}>
      {messages.map(chat => (
        <div key={chat.message}>
          {chat.message ? 
          <div className={`message ${chat.sender}`}>
            {typeof chat.message === 'string' ? <CustomParagraph message={chat.message}/> : <>{chat.message}</>}
          </div> : null
          }
          {chat.options ? (
            <div className="options">
              <div>
                <i className="far fa-hand-pointer"/>
              </div>
              {chat.options.map(option => (
                <p
                  onClick={e => props.optionClick(e)}
                  data-id={option}
                  key={option}
                >
                  {option}
                </p>
              ))}
            </div>
          ) : null}
          <div ref={dummyRef} className="dummy-div"/>
        </div>
      ))}
        <div ref={bottomRef} className="dummy-div"/>
    </div>
  )
}

export default Chats




// WEBPACK FOOTER //
// ./src/organisms/Chats/Chats.tsx